<template>
  <div class="edit-telephone">
    <van-nav-bar
      :title="isNoPhone ? lang.bindRecipientPhone : (isVerification || isSuccess ? lang.newTelJoin : lang.oldTelVer)"
      :left-arrow="!$route.query.fromapp"
      @click-left="$router.go(-1)"
    />
    <div v-if="!isSuccess">
      <!-- 无手机号绑定模式 -->
      <div v-if="isNoPhone">
        <div class="main">
          <div class="tel-number">
            <span class="area-code"> +{{ bindPhoneCode }} </span>
            <input
              v-model="bindPhone"
              type="text"
              maxlength="11"
              :placeholder="lang.setPhone"
              @input="checkInt('bindPhone')"
              @blur="handleBindPhoneBlur"
            >
          </div>
          <div class="tel-code">
            <div class="verify-code">
              <input
                v-model="bindVerifyCode"
                type="text"
                maxlength="4"
                :placeholder="lang.ImgPointLang"
              >
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </div>
            <div style="padding: 2px 15px !important; display: flex; flex-direction: row; justify-content: space-between;">
              <input
                v-model="bindCaptcha"
                type="number"
                :placeholder="lang.setSMSCode"
              >
              <span class="code-img">
                <van-button
                  :class="{ 'get-code': bindPhone }"
                  :disabled="isBindGetCode && bindPhone ? false : true"
                  type="default"
                  @click="bindSendCode"
                >
                  <span v-if="isEnUs">{{ isBindGetCode ? lang.getCaptcha : `${lang.reSetCode}${bindTime}s` }}</span>
                  <span v-else>{{ isBindGetCode ? lang.getCaptcha : `${bindTime}s${lang.reSetCode}` }}</span>
                </van-button>
              </span>
            </div>
          </div>
        </div>
        <div class="btn-sub">
          <van-button
            :disabled="bindCaptcha && bindPhone ? false : true"
            type="danger"
            size="large"
            @click="bindUserPhone"
          >
            {{ lang.confirm }} 
          </van-button>
        </div>
      </div>
      <!-- 有手机号修改模式 - 验证原手机 -->
      <div v-else-if="!isVerification">
        <div class="main">
          <div class="tel-number">
            <!-- 下拉框 暂时只支持香港手机 -->
            <!-- <div v-if="show" class="drop-down">
              <van-button @click="chooseAreaCode('852')" type="default"> +852 </van-button>
              <van-button @click="chooseAreaCode('853')" type="default"> +853 </van-button>
            </div> -->
            <span class="area-code"> +{{ userInfo.phoneCode }} </span>
            <input
              v-model="userInfo.telephone"
              type="text"
              maxlength="8"
              disabled
              :placeholder="lang.setPhone"
            >
          </div>
          <div class="tel-code">
            <div class="verify-code">
              <input
                v-model="verifyCode"
                type="text"
                maxlength="4"
                :placeholder="lang.ImgPointLang"
              >
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </div>
            <div style="padding: 2px 15px !important; display: flex; flex-direction: row; justify-content: space-between;">
              <input
                v-model="captcha"
                type="number"
                :placeholder="lang.setSMSCode"
              >
              <span class="code-img">
                <van-button
                  :class="{ 'get-code': userInfo.telephone }"
                  :disabled="isGetCode ? false : true"
                  type="default"
                  @click="sendCode"
                >
                  <span v-if="isEnUs"> {{ isGetCode ? lang.getCaptcha : `${lang.reSetCode}${time}s` }}</span>
                  <span v-else> {{ isGetCode ? lang.getCaptcha : `${time}s${lang.reSetCode}` }}</span>
                </van-button>
              </span>
            </div>
          </div>
        </div>
        <div class="btn-sub">
          <van-button
            :disabled="captcha ? false : true"
            type="danger"
            size="large"
            @click="oldTelCode"
          >
            {{ lang.verification }}
          </van-button>
        </div>
      </div>
      <!-- 验证成功修改新的电话 -->
      <div v-else>
        <div class="main">
          <div class="tel-number">
            <!-- 下拉框 -->
            <!-- <div v-if="show" class="drop-down">
              <van-button @click="chooseAreaCode('852')" type="default"> +852 </van-button>
              <van-button @click="chooseAreaCode('853')" type="default"> +853 </van-button>
            </div> -->
            <span class="area-code"> +{{ newPhoneCode }} </span>
            <input
              v-model="newPhone"
              type="text"
              maxlength="11"
              :placeholder="lang.setPhone"
              @input="checkInt('newPhone')"
              @blur="handlePhoneBlur"
            >
          </div>
          <div class="tel-code">
            <div class="verify-code">
              <input
                v-model="verifyCode"
                type="text"
                maxlength="4"
                :placeholder="lang.ImgPointLang"
              >
              <img
                :src="verifyImg"
                alt=""
                class="verifyImg"
                @click="loadImg"
              >
            </div>
            <div style="padding: 2px 15px !important; display: flex; flex-direction: row; justify-content: space-between;">
              <input
                v-model="newCaptcha"
                type="number"
                :placeholder="lang.setSMSCode"
              >
              <span class="code-img">
                <van-button
                  :class="{ 'get-code': newPhone }"
                  :disabled="isNewGetCode && newPhone ? false : true"
                  type="default"
                  @click="newSendCode"
                >
                  <span v-if="isEnUs">{{ isNewGetCode ? lang.getCaptcha : `${lang.reSetCode}${newTime}s` }}</span>
                  <span v-else>{{ isNewGetCode ? lang.getCaptcha : `${newTime}s${lang.reSetCode}` }}</span>
                </van-button>
              </span>
            </div>
          </div>
        </div>
        <div class="btn-sub">
          <van-button
            :disabled="newCaptcha && newPhone ? false : true"
            type="danger"
            size="large"
            @click="newTelCode"
          >
            {{ lang.join }}
          </van-button>
        </div>
      </div>
    </div>
    <!-- 修改成功 -->
    <div
      v-else
      class="success"
    >
      <p>
        <span><van-icon name="success" /></span>{{ lang.newPhoneJoinSuc }}
      </p>
      <van-button
        type="danger"
        size="large"
        @click="goPage('edit-user')"
      >
        {{ lang.return }}
      </van-button>
    </div>
  </div>
</template>
<script>
import lang from './../../../common/language/editUser';
export default {
  data() {
    return {
      isEnUs: false,
      userInfo: {},
      isVerification: false,
      isGetCode: true,
      isNewGetCode: true,
      timeID: '',
      newTimeID: '',
      time: 60,
      newTime: 60,
      show: false,
      lang: lang,
      isSuccess: false,
      phone: '',
      phoneCode: '852',
      captcha: '',
      newPhone: '',
      newPhoneCode: '852',
      newCaptcha: '',
      cid: '',
      cacheNum: '',
      verifyImg: '',
      verifyCode: '',
      verifyToken: '',
      // 无手机号绑定模式相关
      isNoPhone: false,
      bindPhone: '',
      bindPhoneCode: '852',
      bindCaptcha: '',
      bindVerifyCode: '',
      bindVerifyToken: '',
      isBindGetCode: true,
      bindTime: 60,
      bindTimeID: '',
    };
  },
  created() {
    if (location.href.indexOf('/en-us') > -1) {this.isEnUs = true;}
    this.axios.get(this.pub.getApi().GetUserInfo).then((res) => {
      if (res.data.code == 0 && res.data.result) {
        this.userInfo = res.data.result;
        // 检查用户是否有手机号，无手机号则进入绑定模式
        if (!this.userInfo.telephone) {
          this.isNoPhone = true;
        }
      } else if (res.data.code == 101) {
        this.pub.delCookie('ERnJaMWtkM');
        this.pub.delCookie('cEVaUDFrZ1kd0RA');
        // this.$router.push('/login/');
        // 第三方登录回调依赖固定的域名 所以改为该方式跳转登录
        let url = this.pub.getLang() === 'zh-cn' ? 'zh-cn/' : this.pub.getLang() === 'en-us' ? 'en-us/' : '';
        window.location.href = this.pub.config.pcUrl+'my/' + url +'login/?tab=1';
      }
    });
    this.loadImg();
  },
  methods: {
    goPage(data) {
      this.$router.push(`/${data}/`);
    },
    /**输入验证 */
    checkInt(field) {
      const num = this[field];
      /^$|^\d+$/.test(num) ? (this.cacheNum = num) : (this[field] = this.cacheNum);
    },
    /**验证新手机验证码 */
    newTelCode() {
      if (!this.newCaptcha) {return;}
      if (this.newPhone.length !== 8) {
        // if (this.newPhone[0] != 9 && this.newPhone[0] != 6 && this.newPhone[0] != 5) {
        //   this.$notify(lang.telError2);
        //   return;
        // }
        if (!/^(4|5|6|7|8|9)/.test(this.newPhone)) {
          this.$notify(lang.telError2);
          return;
        }
        this.$notify(lang.telError1);
        return;
      }
      if (!/^(4|5|6|7|8|9)/.test(this.newPhone)) {
        this.$notify(lang.telError2);
        return;
      }
      this.axios
        .post(this.pub.getApi().ModifyPhone, {
          captcha: this.newCaptcha,
          phoneCode: this.newPhoneCode,
          phone: this.newPhone,
          cid: this.cid,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.isSuccess = true;
          } else if (res.data.code == 1319) {
            // 1319 验证码错误 请重新输入
            this.$notify(lang.smsError);
          } else if (res.data.code == 1309) {
            /**提示手机号已被注册 */
            this.$notify(lang.telNotice);
          } else {
            this.$notify(lang.editError);
          }
        });
    },
    /**验证旧手机验证码 */
    oldTelCode() {
      if (!this.captcha) {return;}
      this.axios
        .post(this.pub.getApi().PreModifyPhone, {
          captcha: this.captcha,
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.cid = res.data.result;
            this.isVerification = true;
            this.verifyCode = '';
            this.loadImg();
          } else if (res.data.code == 1319) {
            // 1319 验证码错误 请重新输入
            this.$notify(lang.smsError);
          }
        });
    },
    /**发送短信 獲取老手機驗證碼*/
    sendCode() {
      if (!this.verifyCode) {
        this.$notify(this.lang.ImgPointLang);
        return;
      }

      this.axios
        .post(this.pub.getApi().SendCaptchaByRecaptcha, {
          phoneCode: this.userInfo.phoneCode,
          phone: this.userInfo.telephone,
        },
        {
          params: {
            'h-recaptchavalue': this.verifyCode,
            'h-recaptcha': this.verifyToken,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.isGetCode = false;
            this.time--;
            this.timeID = setInterval(() => {
              this.time--;
              if (this.time <= 0) {
                this.isGetCode = true;
                this.time = 60;
                clearInterval(this.timeID);
              }
            }, 1000);
          } else if (res.data.code == 101) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          } else if (res.data.code == 103) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          } else if (res.data.code == 104) {
            this.$notify(this.lang.telCodeNotice);
          } else if (res.data.code == 1319) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          }
        });
    },
    /**发送短信 獲取新手機驗證碼*/
    newSendCode() {
      if (!this.verifyCode) {
        this.$notify(this.lang.ImgPointLang);
        return;
      }

      if (this.newPhone.length !== 8) {
        if (!/^(4|5|6|7|8|9)/.test(this.newPhone)) {
          this.$notify(lang.telError2);
          return;
        }
        this.$notify(lang.telError1);
        return;
      }
      if (!/^(4|5|6|7|8|9)/.test(this.newPhone)) {
        this.$notify(lang.telError2);
        return;
      }
      this.axios
        .post(this.pub.getApi().SendCaptchaByRecaptcha, {
          phoneCode: this.newPhoneCode,
          phone: this.newPhone,
        },
        {
          params: {
            'h-recaptchavalue': this.verifyCode,
            'h-recaptcha': this.verifyToken,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.isNewGetCode = false;
            this.newTime--;
            this.newTimeID = setInterval(() => {
              this.newTime--;
              if (this.newTime <= 0) {
                this.isNewGetCode = true;
                this.newTime = 60;
                clearInterval(this.newTimeID);
              }
            }, 1000);
          } else if (res.data.code == 101) {
            this.$notify(lang.smsError);
            this.loadImg();
          } else if (res.data.code == 103) {
            this.$notify(lang.smsError);
            this.loadImg();
          } else if (res.data.code == 104) {
            this.$notify(lang.telCodeNotice);
            this.loadImg();
          }
        });
    },
    /** 加载图形验证码 */
    loadImg() {
      this.axios(this.pub.getApi().GetRecaptcha).then((res) => {
        if (res.data.code === 0) {
          this.verifyImg = 'data:image/png;base64,' + res.data.result.image;
          this.verifyToken = res.data.result.token;
          this.bindVerifyToken = res.data.result.token;
        }
      });
    },
    handlePhoneBlur() {
      if (this.newPhone) {
        this.verifyCode = '';
        this.newCaptcha = '';
        this.loadImg();
      }
    },
    /**手机号输入框失焦 - 绑定模式 */
    handleBindPhoneBlur() {
      if (this.bindPhone) {
        this.bindVerifyCode = '';
        this.bindCaptcha = '';
        this.loadImg();
      }
    },
    /**发送短信验证码 - 绑定手机号模式 */
    bindSendCode() {
      if (!this.bindVerifyCode) {
        this.$notify(this.lang.ImgPointLang);
        return;
      }

      if (this.bindPhone.length !== 8) {
        if (!/^(4|5|6|7|8|9)/.test(this.bindPhone)) {
          this.$notify(lang.telError2);
          return;
        }
        this.$notify(lang.telError1);
        return;
      }
      if (!/^(4|5|6|7|8|9)/.test(this.bindPhone)) {
        this.$notify(lang.telError2);
        return;
      }

      this.axios
        .post(this.pub.getApi().SendCaptchaByRecaptcha, {
          phoneCode: this.bindPhoneCode,
          phone: this.bindPhone,
        },
        {
          params: {
            'h-recaptchavalue': this.bindVerifyCode,
            'h-recaptcha': this.bindVerifyToken,
          },
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.isBindGetCode = false;
            this.bindTime--;
            this.bindTimeID = setInterval(() => {
              this.bindTime--;
              if (this.bindTime <= 0) {
                this.isBindGetCode = true;
                this.bindTime = 60;
                clearInterval(this.bindTimeID);
              }
            }, 1000);
          } else if (res.data.code == 101) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          } else if (res.data.code == 103) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          } else if (res.data.code == 104) {
            this.$notify(this.lang.telCodeNotice);
          } else if (res.data.code == 1319) {
            this.$notify(this.lang.smsError);
            this.loadImg();
          }
        });
    },
    /**绑定手机号 */
    bindUserPhone() {
      if (!this.bindCaptcha) {return;}

      if (this.bindPhone.length !== 8) {
        if (!/^(4|5|6|7|8|9)/.test(this.bindPhone)) {
          this.$notify(lang.telError2);
          return;
        }
        this.$notify(lang.telError1);
        return;
      }
      if (!/^(4|5|6|7|8|9)/.test(this.bindPhone)) {
        this.$notify(lang.telError2);
        return;
      }

      this.axios
        .post(this.pub.getApi().BindUserPhone, {
          captcha: this.bindCaptcha,
          phoneCode: this.bindPhoneCode,
          phone: this.bindPhone,
          cid: '1', // 固定值
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.isSuccess = true;
          } else if (res.data.code == 11002) {
            // 登录用户失效
            this.pub.delCookie('ERnJaMWtkM');
            this.pub.delCookie('cEVaUDFrZ1kd0RA');
            // this.$router.push('/login/');
            let url = this.pub.getLang() === 'zh-cn' ? 'zh-cn/' : this.pub.getLang() === 'en-us' ? 'en-us/' : '';
            window.location.href = this.pub.config.pcUrl+'my/' + url +'login/?tab=1';
          } else if (res.data.code == 13001) {
            // 参数不合法
            this.$notify(lang.editError);
          } else if (res.data.code == 1344) {
            // 首次绑定，用户手机号必须为空（理论上不会出现，因为已校验无手机号）
            this.$notify('绑定异常，请刷新重试');
          } else if (res.data.code == 1309) {
            // 手机号已被其他用户绑定
            this.$notify(lang.telNotice);
          } else if (res.data.code == 1319) {
            // 验证码错误
            this.$notify(lang.smsError);
          } else {
            this.$notify(lang.editError);
          }
        });
    },
  },
  /**选择区号 */
  chooseAreaCode(data) {
    this.phoneCode = data;
    this.show = false;
  },
};
</script>
<style lang="scss" scoped>
.edit-telephone {
  .main {
    padding: 33px 26px;
    input {
      padding: 0;
      margin: 0;
      box-sizing: border-box;
      outline: none;
      border: none;
      padding: 0 2px;
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 15px;
    }
    .tel-number {
      border-bottom: 1px solid #eee;
      position: relative;
      .drop-down {
        width: 20%;
        top: 45px;
        position: absolute;
        .van-button {
          width: 100%;
          display: block;
          height: 44px;
          line-height: 44px;
          &:last-child {
            border-top: none;
          }
        }
      }
      .area-code {
        box-sizing: border-box;
        text-align: center;
        display: inline-block;
        width: 20%;
        height: 24px;
        line-height: 24px;
        border-right: 1px solid #eee;
      }
      input {
        width: 80%;
        padding-left: 16px;
        background-color: #fff;
      }
    }
    .tel-code {
      border-bottom: 1px solid #eee;
      .verify-code {
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        
        input {
          flex: 1;
        }
        
        .verifyImg {
          cursor: pointer;
          height: 30px;
          max-width: 120px;
          margin-left: 10px;
        }
      }
      .code-img {
        display: inline-block;
        // width: 45%;
        height: 50px;
        text-align: right;
        .van-button {
          padding: 0;
          color: #333;
          font-size: 14px;
          border: none;
          width: 100%;
          height: 50px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .get-code {
          color: #0076ff;
        }
      }
      input {
        width: 55%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
  .btn-sub {
    padding: 0 26px;
    p {
      line-height: 50px;
      color: #b2b2b2;
      font-size: 14px;
    }
  }
  .success {
    .login-icon {
      margin-top: 22px;
      .icon-logo {
        height: 100px;
      }
    }
    p {
      font-size: 20px;
      line-height: 48px;
      color: #333;
      padding: 32px 0 24px 0;
      span {
        margin-right: 6px;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        background-color: #4cd964;
        display: inline-block;
        vertical-align: middle;
        .van-icon-success {
          color: #fff;
          font-size: 26px;
          line-height: 48px;
        }
      }
    }
    padding: 0 26px;
  }
}
</style>
